import { FC } from 'react'
import warning from '@/assets/img/icons-error.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={warning}
      alt='Warning'
      width={width}
      height={height}
    />
  )
}

export default Icon
